import { render, staticRenderFns } from "./FullWidthSlider2.vue?vue&type=template&id=cc20d542"
import script from "./FullWidthSlider2.vue?vue&type=script&lang=js"
export * from "./FullWidthSlider2.vue?vue&type=script&lang=js"
import style0 from "./FullWidthSlider2.vue?vue&type=style&index=0&id=cc20d542&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports